import { useContext } from "react";
import type { backendReportConsultationPlannedRowDTO } from "../../backend/target/typescript/dto";
import { AuthContext } from "../auth-context";
import { RequestContext } from "../request-context";
import { requestGet, requireResult } from "../utils/network";
import { getPeriodRange } from "../widget/i-period";
import { Modes } from "../widget/io-abstract";
import IODate from "../widget/io-date";
import IOList from "../widget/io-list";
import SearchPanel, { getPref, type FormValues } from "../widget/search-panel";
import TablePanel from "../widget/table-panel";

// test data: 2015-04-28

type ServerResponse = backendReportConsultationPlannedRowDTO[];

export default function ReportConsultationsPlanned(): React.ReactNode {
  const authenticationContext = useContext(AuthContext)!;
  const requestContext = useContext(RequestContext)!;

  const onSearch = (formData: FormValues): Promise<React.ReactNode> =>
    requestContext
      .fetchJSONAndMessage<ServerResponse>(
        "Generating report",
        requestGet("/api/reports/consultations-planned", {
          ...formData,
          ...getPeriodRange("day", formData["day"], undefined, undefined)
        })
      )
      .then(requireResult)
      .then((list) => (
        <TablePanel
          rows={list}
          headers={
            <thead>
              <tr>
                <th></th>
                <th>Entry Number</th>
                <th>Center</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Purpose</th>
              </tr>
            </thead>
          }
          lineLink={(row) =>
            `/patient/${row.patient_id}/appointment/${row.c_id}`
          }
          lineColumns={(row) => (
            <>
              <td>
                {row.entry_year ?? ""}-{row.entry_order ?? ""}
              </td>
              <td>{row.c_center ?? ""}</td>
              <td>{row.name ?? ""}</td>
              <td>{row.phone ?? ""}</td>
              <td>{row.purpose ?? ""}</td>
            </>
          )}
          reportBasename={`consultations ${formData["day"]}`}
        />
      ));

  return (
    <div>
      <h1>
        <img src="/static/img/reports.gif" />
        Consultations Planned
      </h1>

      <SearchPanel
        form={
          <>
            <IODate
              name="day"
              mode={Modes.input}
              value={getPref("day", new Date().toISOString().substring(0, 10))}
              required
            />
            <IOList
              name="center"
              mode={Modes.input}
              list={authenticationContext.getList("Centers")}
              value={getPref("center", "")}
            />
          </>
        }
        onSearch={onSearch}
      />
    </div>
  );
}
